export default {
  loading: false,
  profileList: [],
  profileTypeList: [],
  currentStep: {
    code: 'list',
    // code: 'edit',
    // code: 'chooseType',
    // code: 'create',
    payload: null
  },
  createTypeId: null,
  editProfileId: null,
  profileProps: [],
  profileName: {
    code: 'profileName',
    value: '',
    name: 'Название профиля'
  }
}



// WEBPACK FOOTER //
// ./src/components/store/modules/profile/state.js